import classes from './SPICell.module.scss';

export const SPICell = ({ value }: { value: number }) => {
    const colorClass = value >= 1 ? 'green' : value < 0.8 ? 'red' : 'orange';
    return <div className={`${classes.SPICellContainer} ${classes[colorClass]}`}>{value}</div>;
};
